/**
 * Split test del percorso d'ingresso — interruttore unico.
 *
 * Il percorso studente e' passato da dodici schermate a cinque. Se il corto
 * esce da solo, fra quattro settimane avremo un numero e niente contro cui
 * metterlo: il confronto naturale sarebbe agosto contro settembre, cioe' la
 * stagionalita', che ci ha gia' ingannato una volta (il -85% giugno→agosto era
 * estate, non prodotto). Questo interruttore fa uscire il corto diviso a meta',
 * cosi' il confronto e' contro persone dello stesso giorno.
 *
 * UNA env var fa tutto: accende, spegne e regola la quota.
 *
 *   REACT_APP_ONBOARDING_LONG_ARM_SHARE = quota (0-100) di persone che vedono
 *   il percorso LUNGO, cioe' quello di prima.
 *
 *     assente / 0 / illeggibile → nessuno vede il lungo: percorso corto per
 *                                 tutti, identico al comportamento di oggi.
 *                                 E' il default sicuro: chi non sa del flag non
 *                                 accende niente per sbaglio.
 *     50                        → meta' e meta'.
 *     100                       → tutti sul lungo (rollback senza revert).
 *
 * Si accende dove si accendono gli altri flag di questo repo: nella riga
 * `build:preproduction` (e poi `build:production`) di `frontend/package.json`,
 * accanto a REACT_APP_FREE_TRIAL_DAYS. Serve un rebuild, mai un revert.
 *
 * A test finito si toglie la variabile e resta il corto per tutti: non c'e'
 * niente da rimettere a posto nel codice.
 */

/** Braccio corto: le cinque schermate di oggi. */
export const FLOW_ARM_SHORT = 'corto';

/** Braccio lungo: il percorso da dodici schermate, quello vero di prima. */
export const FLOW_ARM_LONG = 'lungo';

export const FLOW_ARMS = [FLOW_ARM_SHORT, FLOW_ARM_LONG];

/**
 * Legge la quota dall'ambiente. Tutto cio' che non e' un numero fra 0 e 100
 * vale 0: un refuso nella env var spegne il test, non lo accende a caso.
 */
export const parseLongArmShare = (raw) => {
  const value = parseInt(String(raw ?? '').trim(), 10);
  if (!Number.isFinite(value)) return 0;
  if (value <= 0) return 0;
  if (value >= 100) return 100;
  return value;
};

/**
 * Quota (0-100) di persone assegnate al percorso lungo.
 *
 * A differenza di `config/featureFlags`, qui l'env si legge dentro la funzione
 * e non in una costante all'import. Webpack sostituisce comunque
 * `process.env.REACT_APP_*` a build time, quindi la constant-folding resta,
 * ma i test possono provare quota diversa senza dover ricaricare mezzo albero
 * di moduli (e ritrovarsi due copie di React).
 */
export const getLongArmShare = () => parseLongArmShare(
  process.env.REACT_APP_ONBOARDING_LONG_ARM_SHARE
);

/** Il test e' acceso solo se qualcuno finisce davvero sul lungo. */
export const isOnboardingSplitEnabled = () => getLongArmShare() > 0;
